export const STORAGE_KEY = {
    ACCESS_TOKEN: 'auth._token.local',
    REFRESH_TOKEN: 'auth._refresh_token.local',
    LOCALE: 'i18n_locale',
    DEVICE_TYPE: 'x-device-type',
    MAINTENANCE_WARNING: 'auth.maintenance_warning',
    SITE: 'x-site',
    CURRENCY: 'x-currency',
    ENCRYPTION: 'x-encryption',
    CACHE_CONTROL: 'Cache-Control',
    FBC: '_fbc',
    FBP: '_fbp',
    FBETID: 'x-fb-external-id',
    SIGNATURE: 'x-signature',
};
